export const formatError = (msg) => msg.replace("GraphQL error: ", "");
